var React = require('react');

function BrowserOther (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 8h28v6H6V8zm0 8v16h28V16H6zM4 8a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8zm28 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z","fill":"#fff"}));
}

BrowserOther.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = BrowserOther;

BrowserOther.default = BrowserOther;
